import {
    BEGIN_LOAD_CONFIGURATION,
    END_LOAD_CONFIGURATION_SUCCESS,
    END_LOAD_CONFIGURATION_ERROR,
    Configuration,
    ConfigurationActionTypes
} from "./types";

const initialState: Configuration = {
    clientId: undefined,
    authority: undefined,
    isLoading: false,
    error: null,
    is64Bit: true,
    clientLanguage: "en",
    showWelcomeMessage: false,
    welcomeMessage: [],
    version: "0.0.0.0",
    schema: "0",
    maximumIdleTimeoutForLockoutInSeconds: 900,
    maximumIdleTimeoutForTerminationInSeconds: 1800,
    enableEmbeddedPowerBi: false
};

export default (state: Configuration = initialState, action: ConfigurationActionTypes): Configuration => {
    switch (action.type) {
        case BEGIN_LOAD_CONFIGURATION:
            return { ...state, isLoading: true };

        case END_LOAD_CONFIGURATION_SUCCESS:
            return { ...state, ...action.configuration, isLoading: false };

        case END_LOAD_CONFIGURATION_ERROR:
            return { ...state, isLoading: false, error: action.error };

        default:
            return state;
    }
};
